import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["value"]

import { LanguageDto } from "@api/language-dto";
import { PropType, computed, ref, watch } from "vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSelection',
  props: {
	languages: {
		type: Array as PropType<LanguageDto[]>,
		required: true,
	},
},
  emits: ["langChanged"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const route = useRoute();

const org = computed((): string => {
	const orgParam = route.params.org;
	if (Array.isArray(orgParam)) {
		return orgParam[0];
	} else {
		return orgParam;
	}
});

const lang = computed((): string => {
	const orgParam = route.params.lang;
	if (Array.isArray(orgParam)) {
		return orgParam[0];
	} else {
		return orgParam;
	}
});

const value = ref<string>(lang.value);

watch(
	value,
	() => {
		emit("langChanged", value.value, org.value);
	},
	{ immediate: true }
);

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("select", {
    class: "form-select",
    "aria-label": "Display language selection",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.languages, (lang) => {
      return (_openBlock(), _createElementBlock("option", {
        key: lang.code,
        value: lang.code
      }, _toDisplayString(`${lang.finnish} / ${lang.english}`), 9, _hoisted_1))
    }), 128))
  ], 512)), [
    [_vModelSelect, value.value]
  ])
}
}

})